export default __webpack_public_path__ + "static/media/close-button.44b06c79.svg";